export default {
  patients: {
    label: 'Pacientes',
    patientsList: 'Lista de pacientes',
    viewPatients: 'Exibir pacientes',
    viewPatient: 'Ver paciente',
    newPatient: 'Novo Paciente',
    editPatient: 'Mudar paciente',
    successfullyCreated: 'Paciente criado com sucesso',
    successfullyAddedNote: 'Adicionou uma nova nota com sucesso',
    successfullyAddedRelatedPerson: 'Adicionou uma pessoa relacionada com sucesso',
  },
}
